import scssConstants from './variables.module.scss';

export const styleConstants = {
    barWidth: parseInt(scssConstants.barWidth),
    markerPadding: parseInt(scssConstants.markerPadding),
    markerHeight: parseInt(scssConstants.markerHeight),
    markerMargin: parseInt(scssConstants.markerMargin),
    lineWidth: parseInt(scssConstants.lineWidth),
    headerMargin: parseInt(scssConstants.headerMargin),
    xAxisHeight: parseInt(scssConstants.xAxisHeight),
    spaceAround: parseInt(scssConstants.spaceAround),
    legendColumnMarginBotton: parseInt(scssConstants.legendColumnMarginBotton),

    toolbarHeight: parseInt(scssConstants.toolbarHeight),
    legendInGroupHeight: parseInt(scssConstants.legendInGroupHeight),
    legendInColumnHeight: parseInt(scssConstants.legendInColumnHeight),
};
